<template>
  <ViewContainer>
    <v-row>
      <v-col md="10" offset-md="1" class="mt-16">
        <v-row>
          <v-col>
            <img
              width="600"
              height="400"
              class="pb-4 mt-10"
              :src="image"
              alt="empty_state_404"
            />
          </v-col>
          <v-col class="align-self-center">
            <div>
              <p class="h3 font-bold mb-4">
                {{ $t('error.network_error_title') }}
              </p>
              <p class="body-1 blue-grey--text text--darken-2 mb-6">
                {{ $t('error.network_error_description') }}
              </p>

              <div class="d-flex flex-column justify-center align-center">
                <Button
                  color="primary"
                  :loading="isLoading"
                  :text="$t('common.retry')"
                  @click="tryAgain"
                />

                <p class="caption blue-grey--text text--darken-2 mt-4 mb-2">
                  {{ $t('common.or') }}
                </p>

                <Button
                  color="primary"
                  plain
                  :to="{ name: 'logout' }"
                  :disabled="isLoading"
                  :text="$t('error.network_error_login_again')"
                />
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </ViewContainer>
</template>

<script>
import { mapActions } from 'vuex'

import mixin from '@/mixins/mixin.vue'

import ViewContainer from '@/components/Core/Layout/ViewContainer.vue'
import Button from '@/components/UI/Button'
import image from '@/assets/images/empty-states/satellite-empty-state.svg'

export default {
  name: 'NetworkErrorView',

  mixins: [mixin],

  components: {
    ViewContainer,
    Button,
  },

  data() {
    return {
      image,
      isLoading: false,
    }
  },

  mounted() {
    this.$store.dispatch('hideLoader')
  },

  methods: {
    ...mapActions({
      getMe: 'getMe',
    }),

    async tryAgain() {
      this.isLoading = true

      try {
        await this.getMe()
        const route = this.$route.query.redirect ?? '/home'
        this.replaceRoute(route)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
